import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const IntelligentContactGrid = () => {
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [viewMode, setViewMode] = useState('grid');
  const [sortBy, setSortBy] = useState('engagement');

  const contacts = [
  {
    id: 1,
    name: "Sophie Dubois",
    email: "sophie.dubois@entreprise.fr",
    phone: "+33 6 12 34 56 78",
    company: "TechCorp France",
    position: "Directrice Marketing",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_116492473-1763296099355.png",
    avatarAlt: "Professional headshot of French woman with shoulder-length brown hair in navy blazer smiling warmly",
    engagementScore: 92,
    lastInteraction: "Il y a 2 heures",
    interactionCount: 47,
    preferredChannel: "email",
    tags: ["VIP", "Décideur"],
    completeness: 95,
    status: "active"
  },
  {
    id: 2,
    name: "Marc Lefebvre",
    email: "m.lefebvre@solutions.fr",
    phone: "+33 6 23 45 67 89",
    company: "Solutions Digitales",
    position: "Responsable Commercial",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_15a24c757-1763292886293.png",
    avatarAlt: "Professional headshot of French man with short dark hair in gray suit with confident expression",
    engagementScore: 85,
    lastInteraction: "Il y a 5 heures",
    interactionCount: 38,
    preferredChannel: "phone",
    tags: ["Prospect chaud"],
    completeness: 88,
    status: "active"
  },
  {
    id: 3,
    name: "Claire Martin",
    email: "claire.martin@innovation.fr",
    phone: "+33 6 34 56 78 90",
    company: "Innovation Labs",
    position: "Chef de Projet",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1b5600450-1763294005133.png",
    avatarAlt: "Professional headshot of French woman with blonde hair in white blouse with friendly smile",
    engagementScore: 78,
    lastInteraction: "Il y a 1 jour",
    interactionCount: 29,
    preferredChannel: "meeting",
    tags: ["Nouveau contact"],
    completeness: 82,
    status: "active"
  },
  {
    id: 4,
    name: "Thomas Bernard",
    email: "t.bernard@consulting.fr",
    phone: "+33 6 45 67 89 01",
    company: "Consulting Partners",
    position: "Consultant Senior",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1134ccfa4-1763292342884.png",
    avatarAlt: "Professional headshot of French man with glasses and beard in dark blue suit with serious expression",
    engagementScore: 71,
    lastInteraction: "Il y a 3 jours",
    interactionCount: 22,
    preferredChannel: "email",
    tags: ["Suivi régulier"],
    completeness: 76,
    status: "active"
  },
  {
    id: 5,
    name: "Isabelle Rousseau",
    email: "i.rousseau@services.fr",
    phone: "+33 6 56 78 90 12",
    company: "Services Pro",
    position: "Directrice Générale",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_115d31a15-1763298122976.png",
    avatarAlt: "Professional headshot of French woman with short red hair in burgundy blazer with executive presence",
    engagementScore: 95,
    lastInteraction: "Il y a 1 heure",
    interactionCount: 53,
    preferredChannel: "phone",
    tags: ["VIP", "Décideur", "Client fidèle"],
    completeness: 98,
    status: "active"
  },
  {
    id: 6,
    name: "Pierre Moreau",
    email: "p.moreau@tech.fr",
    phone: "+33 6 67 89 01 23",
    company: "Tech Innovations",
    position: "Ingénieur Commercial",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_15a24c757-1763292886293.png",
    avatarAlt: "Professional headshot of French man with short black hair in light gray suit with approachable smile",
    engagementScore: 68,
    lastInteraction: "Il y a 5 jours",
    interactionCount: 18,
    preferredChannel: "chat",
    tags: ["Prospect froid"],
    completeness: 71,
    status: "inactive"
  }];


  const handleSelectContact = (contactId) => {
    setSelectedContacts((prev) =>
    prev?.includes(contactId) ?
    prev?.filter((id) => id !== contactId) :
    [...prev, contactId]
    );
  };

  const handleSelectAll = () => {
    if (selectedContacts?.length === contacts?.length) {
      setSelectedContacts([]);
    } else {
      setSelectedContacts(contacts?.map((c) => c?.id));
    }
  };

  const getEngagementColor = (score) => {
    if (score >= 80) return 'text-success';
    if (score >= 60) return 'text-secondary';
    if (score >= 40) return 'text-warning';
    return 'text-error';
  };

  const getChannelIcon = (channel) => {
    switch (channel) {
      case 'email':return 'Mail';
      case 'phone':return 'Phone';
      case 'meeting':return 'Calendar';
      case 'chat':return 'MessageSquare';
      default:return 'Mail';
    }
  };

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-elevation-2">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
        <div>
          <h2 className="text-lg md:text-xl font-semibold text-foreground mb-1">
            Contacts intelligents
          </h2>
          <p className="text-sm text-muted-foreground">
            {contacts?.length} contacts • {selectedContacts?.length} sélectionné(s)
          </p>
        </div>

        <div className="flex items-center gap-2 flex-wrap">
          <div className="flex items-center gap-1 bg-muted rounded-lg p-1">
            <button
              onClick={() => setViewMode('grid')}
              className={`p-2 rounded transition-smooth ${
              viewMode === 'grid' ? 'bg-background shadow-sm' : 'hover:bg-background/50'}`
              }>

              <Icon name="LayoutGrid" size={16} />
            </button>
            <button
              onClick={() => setViewMode('list')}
              className={`p-2 rounded transition-smooth ${
              viewMode === 'list' ? 'bg-background shadow-sm' : 'hover:bg-background/50'}`
              }>

              <Icon name="List" size={16} />
            </button>
          </div>

          <select
            value={sortBy}
            onChange={(e) => setSortBy(e?.target?.value)}
            className="px-3 py-2 bg-muted rounded-lg text-sm font-medium text-foreground border-none outline-none cursor-pointer">

            <option value="engagement">Score d'engagement</option>
            <option value="recent">Plus récent</option>
            <option value="name">Nom A-Z</option>
            <option value="company">Entreprise</option>
          </select>

          <button
            onClick={handleSelectAll}
            className="px-3 py-2 bg-muted hover:bg-muted/80 rounded-lg text-sm font-medium text-foreground transition-smooth">

            {selectedContacts?.length === contacts?.length ? 'Tout désélectionner' : 'Tout sélectionner'}
          </button>
        </div>
      </div>
      {selectedContacts?.length > 0 &&
      <div className="mb-4 p-3 bg-primary/10 rounded-lg flex items-center justify-between">
          <span className="text-sm font-medium text-primary">
            {selectedContacts?.length} contact(s) sélectionné(s)
          </span>
          <div className="flex items-center gap-2">
            <button className="px-3 py-1.5 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition-smooth">
              Exporter
            </button>
            <button className="px-3 py-1.5 bg-secondary text-secondary-foreground rounded-lg text-sm font-medium hover:bg-secondary/90 transition-smooth">
              Fusionner
            </button>
            <button className="px-3 py-1.5 bg-error text-error-foreground rounded-lg text-sm font-medium hover:bg-error/90 transition-smooth">
              Supprimer
            </button>
          </div>
        </div>
      }
      <div className={viewMode === 'grid' ? 'grid grid-cols-1 md:grid-cols-2 gap-4' : 'space-y-3'
      }>
        {contacts?.map((contact) =>
        <div
          key={contact?.id}
          className={`p-4 border border-border rounded-lg hover:border-primary/50 transition-smooth ${
          selectedContacts?.includes(contact?.id) ? 'bg-primary/5 border-primary' : 'bg-background'}`
          }>

            <div className="flex items-start gap-3 mb-3">
              <input
              type="checkbox"
              checked={selectedContacts?.includes(contact?.id)}
              onChange={() => handleSelectContact(contact?.id)}
              className="mt-1 w-4 h-4 rounded border-border cursor-pointer" />

              
              <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                <Image
                src={contact?.avatar}
                alt={contact?.avatarAlt}
                className="w-full h-full object-cover" />

              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-1">
                  <h3 className="text-sm font-semibold text-foreground line-clamp-1">
                    {contact?.name}
                  </h3>
                  <div className={`flex items-center gap-1 ${getEngagementColor(contact?.engagementScore)}`}>
                    <Icon name="TrendingUp" size={14} />
                    <span className="text-xs font-semibold whitespace-nowrap">
                      {contact?.engagementScore}
                    </span>
                  </div>
                </div>
                
                <p className="text-xs text-muted-foreground line-clamp-1 mb-1">
                  {contact?.position} • {contact?.company}
                </p>
                
                <div className="flex items-center gap-2 text-xs text-muted-foreground mb-2">
                  <Icon name={getChannelIcon(contact?.preferredChannel)} size={12} />
                  <span className="line-clamp-1">{contact?.email}</span>
                </div>

                <div className="flex items-center gap-1 flex-wrap">
                  {contact?.tags?.map((tag, index) =>
                <span
                  key={index}
                  className="px-2 py-0.5 bg-secondary/10 text-secondary rounded text-xs font-medium">

                      {tag}
                    </span>
                )}
                </div>
              </div>
            </div>

            <div className="flex items-center justify-between pt-3 border-t border-border">
              <div className="flex items-center gap-4 text-xs text-muted-foreground">
                <div className="flex items-center gap-1">
                  <Icon name="MessageCircle" size={12} />
                  <span>{contact?.interactionCount}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Icon name="Clock" size={12} />
                  <span className="whitespace-nowrap">{contact?.lastInteraction}</span>
                </div>
              </div>

              <div className="flex items-center gap-1">
                <button
                className="p-1.5 hover:bg-muted rounded transition-smooth"
                title="Appeler">

                  <Icon name="Phone" size={14} />
                </button>
                <button
                className="p-1.5 hover:bg-muted rounded transition-smooth"
                title="Envoyer un email">

                  <Icon name="Mail" size={14} />
                </button>
                <button
                className="p-1.5 hover:bg-muted rounded transition-smooth"
                title="Plus d'options">

                  <Icon name="MoreVertical" size={14} />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="mt-6 flex items-center justify-between">
        <p className="text-sm text-muted-foreground">
          Affichage de 1-6 sur {contacts?.length} contacts
        </p>
        <div className="flex items-center gap-2">
          <button className="px-3 py-2 bg-muted hover:bg-muted/80 rounded-lg text-sm font-medium text-foreground transition-smooth disabled:opacity-50 disabled:cursor-not-allowed">
            Précédent
          </button>
          <button className="px-3 py-2 bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg text-sm font-medium transition-smooth">
            Suivant
          </button>
        </div>
      </div>
    </div>);

};

export default IntelligentContactGrid;